"use client";
import { MuiAccordionTheme } from "../components/Accordion/Accordion.theme";
import { MuiAccordionDetailsTheme } from "../components/AccordionDetails/AccordionDetails.theme";
import { MuiAccordionSummaryTheme } from "../components/AccordionSummary/AccordionSummary.theme";
import { MuiAlertTheme } from "../components/Alert/Alert.theme";
import { MuiAppBarTheme } from "../components/AppBar/AppBar.theme";
import { MuiAutocompleteTheme } from "../components/Autocomplete/Autocomplete.theme";
import { MuiAvatarTheme } from "../components/Avatar/Avatar.theme";
import { MuiBackdropTheme } from "../components/Backdrop/Backdrop.theme";
import { MuiBadgeTheme } from "../components/Badge/Badge.theme";
import { MuiBottomNavigationTheme } from "../components/BottomNavigation/BottomNavigation.theme";
import { MuiBottomNavigationActionTheme } from "../components/BottomNavigation/BottomNavigationAction.theme";
import { MuiBreadcrumbsTheme } from "../components/Breadcrumbs/Breadcrumbs.theme";
import { MuiButtonTheme } from "../components/Button/Button.theme";
import { MuiButtonGroupTheme } from "../components/ButtonGroup/ButtonGroup.theme";
import { MuiCardTheme } from "../components/Card/Card.theme";
import { MuiCardActionAreaTheme } from "../components/CardActionArea/CardActionArea.theme";
import { MuiCardActionsTheme } from "../components/CardActions/CardActions.theme";
import { MuiCardContentTheme } from "../components/CardContent/CardContent.theme";
import { MuiCardHeaderTheme } from "../components/CardHeader/CardHeader.theme";
import { MuiCardMediaTheme } from "../components/CardMedia/CardMedia.theme";
import { MuiCheckboxTheme } from "../components/Checkbox/Checkbox.theme";
import { MuiChipTheme } from "../components/Chip/Chip.theme";
import { MuiDialogTheme } from "../components/Dialog/Dialog.theme";
import { MuiDialogActionsTheme } from "../components/DialogActions/DialogActions.theme";
import { MuiDialogContentTheme } from "../components/DialogContent/DialogContent.theme";
import { MuiDialogContentTextTheme } from "../components/DialogContentText/DialogContentText.theme";
import { MuiDialogTitleTheme } from "../components/DialogTitle/DialogTitle.theme";
import { MuiDividerTheme } from "../components/Divider/Divider.theme";
import { MuiFabTheme } from "../components/Fab/Fab.theme";
import { MuiFormControlLabelTheme } from "../components/FormControlLabel/FormControlLabel.theme";
import { MuiFormHelperTextTheme } from "../components/FormHelperText/FormHelperText.theme";
import { MuiIconTheme } from "../components/Icon/Icon.theme";
import { MuiIconButtonTheme } from "../components/IconButton/IconButton.theme";
import { MuiInputLabelTheme } from "../components/InputLabel/InputLabel.theme";
import { MuiLinkTheme } from "../components/Link/Link.theme";
import { MuiListTheme } from "../components/List/List.theme";
import { MuiListItemTheme } from "../components/List/ListItem.theme";
import { MuiListItemAvatarTheme } from "../components/List/ListItemAvatar.theme";
import { MuiListItemButtonTheme } from "../components/List/ListItemButton.theme";
import { MuiListItemIconTheme } from "../components/List/ListItemIcon.theme";
import { MuiListItemTextTheme } from "../components/List/ListItemText.theme";
import { MuiListSubheaderTheme } from "../components/List/ListSubheader.theme";
import { MuiMenuItemTheme } from "../components/MenuItem/MenuItem.theme";
import { MuiPaginationTheme } from "../components/Pagination/Pagination.theme";
import { MuiPaginationItemTheme } from "../components/Pagination/PaginationItem.theme";
import { MuiPaperTheme } from "../components/Paper/Paper.theme";
import { MuiCircularProgressTheme } from "../components/Progress/CircularProgress.theme";
import { MuiLinearProgressTheme } from "../components/Progress/LinearProgress.theme";
import { MuiRadioTheme } from "../components/RadioButton/Radio.theme";
import { MuiSelectTheme } from "../components/Select/Select.theme";
import { MuiSkeletonTheme } from "../components/Skeleton/Skeleton.theme";
import { MuiSliderTheme } from "../components/Slider/Slider.theme";
import { MuiSnackbarContentTheme } from "../components/SnackbarContent/SnackbarContent.theme";
import { MuiStepTheme } from "../components/Step/Step.theme";
import { MuiStepButtonTheme } from "../components/StepButton/StepButton.theme";
import { MuiStepConnectorTheme } from "../components/StepConnector/StepConnector.theme";
import { MuiStepIconTheme } from "../components/StepIcon/StepIcon.theme";
import { MuiStepLabelTheme } from "../components/StepLabel/StepLabel.theme";
import { MuiStepperTheme } from "../components/Stepper/Stepper.theme";
import { MuiSvgIconTheme } from "../components/SvgIcon/SvgIcon.theme";
import { MuiSwitchTheme } from "../components/Switch/Switch.theme";
import { MuiTableTheme } from "../components/Table/Table.theme";
import { MuiTableBodyTheme } from "../components/TableBody/TableBody.theme";
import { MuiTableCellTheme } from "../components/TableCell/TableCell.theme";
import { MuiTableContainerTheme } from "../components/TableContainer/TableContainer.theme";
import { MuiTableFooterTheme } from "../components/TableFooter/TableFooter.theme";
import { MuiTableHeadTheme } from "../components/TableHead/TableHead.theme";
import { MuiTablePaginationTheme } from "../components/TablePagination/TablePagination.theme";
import { MuiTableRowTheme } from "../components/TableRow/TableRow.theme";
import { MuiTableSortLabelTheme } from "../components/TableSortLabel/TableSortLabel.theme";
import { MuiTabTheme } from "../components/Tabs/Tab.theme";
import { MuiTabsTheme } from "../components/Tabs/Tabs.theme";
import { MuiInputBaseTheme, MuiOutlinedInputTheme, MuiTextFieldTheme } from "../components/TextField/Textfield.theme";
import { MuiToggleButtonTheme } from "../components/ToggleButton/ToggleButton.theme";
import { MuiToggleButtonGroupTheme } from "../components/ToggleButtonGroup/ToggleButtonGroup.theme";
import { MuiTooltipTheme } from "../components/Tooltip/Tooltip.theme";
import { MuiTypographyTheme, typographyTheme } from "../components/Typography/Typography.theme";
import { fontsCss } from "../fonts/utils/font";
import { themeBreakpoints } from "./utils/themeBreakpoints.module";
export const getThemeOptions = (dt) => {
    const muiSelect = MuiSelectTheme(dt);
    const themeOptions = {
        breakpoints: themeBreakpoints,
        components: {
            MuiCssBaseline: {
                styleOverrides: fontsCss(dt),
            },
            MuiAccordion: MuiAccordionTheme(dt),
            MuiAccordionSummary: MuiAccordionSummaryTheme(dt),
            MuiAccordionDetails: MuiAccordionDetailsTheme(),
            MuiAlert: MuiAlertTheme(dt),
            MuiAppBar: MuiAppBarTheme(),
            MuiAutocomplete: MuiAutocompleteTheme(dt),
            MuiAvatar: MuiAvatarTheme(dt),
            MuiBackdrop: MuiBackdropTheme(dt),
            MuiBadge: MuiBadgeTheme(dt),
            MuiBottomNavigation: MuiBottomNavigationTheme(dt),
            MuiBottomNavigationAction: MuiBottomNavigationActionTheme(dt),
            MuiBreadcrumbs: MuiBreadcrumbsTheme(dt),
            MuiButton: MuiButtonTheme(dt),
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiButtonGroup: MuiButtonGroupTheme(dt),
            MuiCheckbox: MuiCheckboxTheme(dt),
            MuiCard: MuiCardTheme(dt),
            MuiCardActionArea: MuiCardActionAreaTheme(dt),
            MuiCardActions: MuiCardActionsTheme(dt),
            MuiCardContent: MuiCardContentTheme(dt),
            MuiCardHeader: MuiCardHeaderTheme(dt),
            MuiCardMedia: MuiCardMediaTheme(),
            MuiChip: MuiChipTheme(dt),
            MuiCircularProgress: MuiCircularProgressTheme(),
            MuiDivider: MuiDividerTheme(dt),
            MuiDialog: MuiDialogTheme(dt),
            MuiDialogActions: MuiDialogActionsTheme(dt),
            MuiDialogContent: MuiDialogContentTheme(dt),
            MuiDialogContentText: MuiDialogContentTextTheme(dt),
            MuiDialogTitle: MuiDialogTitleTheme(dt),
            MuiIcon: MuiIconTheme(dt),
            MuiIconButton: MuiIconButtonTheme(dt),
            MuiInputBase: MuiInputBaseTheme(dt),
            MuiInputLabel: MuiInputLabelTheme(dt),
            MuiFab: MuiFabTheme(dt),
            MuiFormControlLabel: MuiFormControlLabelTheme(),
            MuiFormHelperText: MuiFormHelperTextTheme(dt),
            MuiList: MuiListTheme(dt),
            MuiListItem: MuiListItemTheme(dt),
            MuiListItemAvatar: MuiListItemAvatarTheme(),
            MuiListItemIcon: MuiListItemIconTheme(),
            MuiListItemButton: MuiListItemButtonTheme(dt),
            MuiListItemText: MuiListItemTextTheme(dt),
            MuiListSubheader: MuiListSubheaderTheme(dt),
            //MuiMenu: MuiMenuTheme(), // Doesn't accept themed styling for some reason
            MuiMenuItem: MuiMenuItemTheme(dt),
            MuiLink: MuiLinkTheme(dt),
            MuiLinearProgress: MuiLinearProgressTheme(dt),
            MuiNativeSelect: muiSelect,
            MuiOutlinedInput: MuiOutlinedInputTheme(dt),
            MuiPaper: MuiPaperTheme(dt),
            MuiPagination: MuiPaginationTheme(dt),
            MuiPaginationItem: MuiPaginationItemTheme(dt),
            MuiRadio: MuiRadioTheme(dt),
            MuiSvgIcon: MuiSvgIconTheme(dt),
            MuiSelect: muiSelect,
            MuiSlider: MuiSliderTheme(dt),
            MuiSnackbarContent: MuiSnackbarContentTheme(dt),
            MuiSkeleton: MuiSkeletonTheme(dt),
            MuiStep: MuiStepTheme(dt),
            MuiStepper: MuiStepperTheme(dt),
            MuiStepIcon: MuiStepIconTheme(dt),
            MuiStepLabel: MuiStepLabelTheme(dt),
            MuiStepButton: MuiStepButtonTheme(dt),
            MuiStepConnector: MuiStepConnectorTheme(),
            MuiSwitch: MuiSwitchTheme(dt),
            MuiTabs: MuiTabsTheme(dt),
            MuiTab: MuiTabTheme(dt),
            MuiTable: MuiTableTheme(),
            MuiTableBody: MuiTableBodyTheme(),
            MuiTableCell: MuiTableCellTheme(dt),
            MuiTableContainer: MuiTableContainerTheme(),
            MuiTableHead: MuiTableHeadTheme(dt),
            MuiTableFooter: MuiTableFooterTheme(),
            MuiTablePagination: MuiTablePaginationTheme(),
            MuiTableSortLabel: MuiTableSortLabelTheme(),
            MuiTableRow: MuiTableRowTheme(),
            MuiTextField: MuiTextFieldTheme(dt),
            MuiToggleButton: MuiToggleButtonTheme(dt),
            MuiToggleButtonGroup: MuiToggleButtonGroupTheme(dt),
            MuiTooltip: MuiTooltipTheme(dt),
            MuiTypography: MuiTypographyTheme(dt),
        },
        palette: {
            primary: {
                main: dt.color.primary.key,
            },
            secondary: {
                main: dt.color.secondary.key,
            },
            error: {
                main: dt.color.signal.error.key,
            },
            warning: {
                main: dt.color.signal.warning.key,
            },
            info: {
                main: dt.color.signal.info.key,
            },
            success: {
                main: dt.color.signal.success.key,
            },
            neutral: {
                main: dt.cta.contained.color.background.neutral.default,
            },
            inverted: {
                main: dt.cta.contained.color.background.inverted.default,
            },
            invertedPrimary: {
                main: dt.cta.contained.color.background.inverted.default,
            },
            text: {
                primary: dt.color.onSurface.key,
                secondary: dt.color.onSurface.variant,
            },
        },
        pixel: dt,
        typography: typographyTheme(dt),
    };
    return themeOptions;
};
